<template>
    <ClientOnly>
        <VJoyIconButton variant="ghost" icon="add" size="small" :label="$t('general.add')" @click="openCertificationsAddDialog" />
        <template #fallback>
            <SectionActionSkeleton />
        </template>
    </ClientOnly>
</template>

<script setup lang="ts">
    import {VJoyIconButton} from '@maltjoy/core-vue';
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import {eventBus} from '~/config/events';
    import {EditionOpenedEntryPoint} from '~/config/TrackingEvents';

    function openCertificationsAddDialog() {
        eventBus.emit('certifications:edit-mode', {certificationId: undefined, entryPoint: EditionOpenedEntryPoint.PROFILE_PAGE});
    }
</script>
